"use client";

import * as React from "react";
import SharedShellFrame, {
  SHELL_RAIL_WIDTH,
  type ShellColumns,
  type ShellFrameProps as SharedShellFrameProps,
} from "@workspace/ui/components/shell-frame";

import ResizeHandle from "./article-shell/ResizeHandle";

export type { ShellColumns };
export const RAIL_WIDTH = SHELL_RAIL_WIDTH;

export interface ShellFrameProps
  extends Omit<
    SharedShellFrameProps,
    "leftResizeHandle" | "rightResizeHandle"
  > {
  onResizeLeft?: (px: number) => void;
  onResizeRight?: (px: number) => void;
  showRightResize?: boolean;
}

/**
 * 셸 리사이즈 어댑터.
 *
 * 셸의 DOM·컬럼·sticky 크롬은 @workspace/ui 의 공통 ShellFrame 이 소유하고,
 * 여기서는 컬럼 구성에 맞는 ResizeHandle 배치만 더한다.
 *
 * `rail`·`header` 는 앱이 채우는 순수 슬롯이다. 앱 고유 레일·헤더를 여기서 기본값으로
 * 넣으면 공용 패키지가 특정 앱 소스를 다시 물게 되므로, 그 조립은 각 앱의 어댑터가 맡는다.
 */
export default function ShellFrame({
  columns,
  rail,
  header,
  onResizeLeft,
  onResizeRight,
  showLeftContent = true,
  showRightResize = true,
  ...frameProps
}: ShellFrameProps) {
  const hasLeftColumn =
    columns === "left+main" || columns === "left+main+right";
  const hasRightColumn = columns === "left+main+right";

  return (
    <SharedShellFrame
      {...frameProps}
      columns={columns}
      rail={rail}
      header={header}
      showLeftContent={showLeftContent}
      leftResizeHandle={
        hasLeftColumn && showLeftContent && onResizeLeft ? (
          <ResizeHandle side="left" onResize={onResizeLeft} />
        ) : undefined
      }
      rightResizeHandle={
        hasRightColumn && showRightResize && onResizeRight ? (
          <ResizeHandle side="right" onResize={onResizeRight} />
        ) : undefined
      }
    />
  );
}
